var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-form", { attrs: { "label-position": "top" } }, [
        _c("div", { staticClass: "contactum_card" }, [
          _c("div", { staticClass: "contactum_card_head" }, [
            _c("h2", { staticClass: "title" }, [
              _vm._v("  hCaptcha Settings ")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text" }, [
              _vm._v(
                " Contactum integrates with hCaptcha, a free service that protects your website from spam and abuse. Please note, these settings are required only if you decide to use the hCaptcha field. Read more about hCaptcha.\n          Please generate API key and API secret using hCaptcha >\n          "
              ),
              _c(
                "a",
                {
                  attrs: { href: "https://www.hcaptcha.com/", target: "_blank" }
                },
                [_vm._v("Read more about hCaptcha.")]
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text" }, [
              _c("b", [
                _vm._v("Please generate API key and API secret using hCaptcha")
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contactum_card_bodya" },
            [
              _c(
                "el-form-item",
                { staticClass: "contactum-form-item" },
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _vm._v("\n          Site Key\n          "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            placement: "bottom-start",
                            "popper-class": "contactum_tooltip_wrap"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("p", [
                                _vm._v(
                                  "Enter your hCaptcha Site Key, if you do not have a key you can register for one at the provided link,  hCaptcha is a free service."
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "text-primary" })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    on: { change: _vm.load },
                    model: {
                      value: _vm.hCaptcha.siteKey,
                      callback: function($$v) {
                        _vm.$set(_vm.hCaptcha, "siteKey", $$v)
                      },
                      expression: "hCaptcha.siteKey"
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "contactum-form-item" },
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _vm._v("\n          Secret Key\n          "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            placement: "bottom-start",
                            "popper-class": "contactum_tooltip_wrap"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("p", [
                                _vm._v(
                                  "Enter your hCaptcha Secret Key, if you do not have a key you can register for one at the provided link. hCaptcha is a free service."
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "text-primary" })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { type: "password" },
                    on: { change: _vm.load },
                    model: {
                      value: _vm.hCaptcha.secretKey,
                      callback: function($$v) {
                        _vm.$set(_vm.hCaptcha, "secretKey", $$v)
                      },
                      expression: "hCaptcha.secretKey"
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.siteKeyChanged
                ? _c("el-form-item", { attrs: { label: "Validate Keys" } }, [
                    _c("div", {
                      staticClass: "h-captcha",
                      attrs: {
                        id: "hCaptcha",
                        "data-sitekey": _vm.hCaptcha.siteKey
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hCaptcha_status
                ? _c("div", { attrs: { size: "sm", type: "success-soft" } }, [
                    _c("p", [_vm._v(" Your hCaptcha is valid ")])
                  ])
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  icon: "el-icon-success",
                  disabled: _vm.disabled,
                  loading: false
                },
                on: { click: _vm.save }
              },
              [_vm._v("Save Settings")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "danger",
                  icon: "ff-icon ff-icon-trash",
                  clearing: false
                },
                on: { click: _vm.clearSettings }
              },
              [_vm._v("Clear Settings")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }